import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { TASK_CATEGORIES_ACTION_TYPE } from '../actions';
import { TASK_TYPES_ACTION_TYPE } from '../actions/taskTypes.actions';

const initialState = {};

const taskTypesReducer = (state = initialState, { payload, type }) =>
  produce(state, draft => {
    switch (type) {
      case TASK_TYPES_ACTION_TYPE.GET_TASK_TYPES:
        return payload;

      case TASK_CATEGORIES_ACTION_TYPE.DELETE_TASK_CATEGORY:
        Object.values(state).forEach(({ taskCategoryId, taskTypeId }) => {
          if (taskCategoryId === payload) {
            draft[taskTypeId].taskCategoryId = null;
          }
        });

        break;

      case TASK_TYPES_ACTION_TYPE.DELETE_TASK_TYPE:
        delete draft[payload];
        break;

      case TASK_TYPES_ACTION_TYPE.EDIT_TASK_TYPE:
      case TASK_TYPES_ACTION_TYPE.ADD_TASK_TYPE:
        draft[payload.taskTypeId] = {
          ...payload,
          isExcluded: !!draft[payload.taskTypeId]?.isExcluded,
        };

        break;

      case TASK_TYPES_ACTION_TYPE.CHANGE_TASK_TYPE_ACTIVITY:
        draft[payload].isExcluded = !draft[payload].isExcluded;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });
export default taskTypesReducer;
